import React from "react";
import { FileDisplayContainer, FileIcon, FileName, RemoveFileButton, SpinnerIcon, SpinnerIconContainer, ProgressPercent } from "./FileToDisplay.styles";
import { FilesDisplayProps } from "./FileToDisplay.types";
import fileIcon from "../../assets/icons/fileIcon.svg";
import videoFileIcon from "../../assets/icons/videoFileIcon.svg";
import spinnerFrame0 from "../../assets/icons/spinner_frame_0.svg";
import spinnerFrame1 from "../../assets/icons/spinner_frame_1.svg";
import spinnerFrame2 from "../../assets/icons/spinner_frame_2.svg";
import spinnerFrame3 from "../../assets/icons/spinner_frame_3.svg";
import { Tooltip } from "primereact/tooltip";

const spinnerFrames = [spinnerFrame0, spinnerFrame1, spinnerFrame2, spinnerFrame3];

const FileToDisplay: React.FC<FilesDisplayProps> = ({ files_from_storage, onRemoveFile }) => {
  // Сортируем файлы: сначала не в обработке (по id), затем в обработке (по id)
  const sortedFiles = [...files_from_storage].sort((a, b) => {
    const aProcessing = a.type === "video" && a.status === "processing";
    const bProcessing = b.type === "video" && b.status === "processing";
    
    // Файлы в обработке идут правее (позже в массиве)
    if (aProcessing !== bProcessing) {
      return aProcessing ? 1 : -1;
    }
    
    // Второй приоритет - сортировка по id
    return a.id - b.id;
  });

  return (
    <>
      {sortedFiles.map((file, index) => {
        const isProcessing = file.type === "video" && file.status === "processing";
        const progressPercent = file.progress_percent !== undefined && file.progress_percent > 0 
          ? file.progress_percent 
          : null;
        
        const iconElement = isProcessing ? (
          <SpinnerIconContainer>
            <SpinnerIcon $frames={spinnerFrames} />
            {progressPercent !== null && (
              <ProgressPercent>{progressPercent}%</ProgressPercent>
            )}
          </SpinnerIconContainer>
        ) : (
          <FileIcon 
            src={file.type === "video" ? videoFileIcon : fileIcon} 
            alt={file.type === "video" ? "Видео" : "Файл"} 
          />
        );

        const displayName = isProcessing && progressPercent !== null
          ? `Обработка... ${progressPercent}%`
          : isProcessing
          ? "Обработка..."
          : file.name;

        return (
          <React.Fragment key={file.id}>
            <Tooltip
              target={`.file-link-${index}`}
              content={file.name}
              mouseTrack
              mouseTrackLeft={10}
            />

            <FileDisplayContainer>
              {isProcessing ? (
                <div className={`file-link-${index}`} style={{ pointerEvents: "none", cursor: "not-allowed" }}>
                  {iconElement}
                  <FileName>{displayName}</FileName>
                </div>
              ) : (
                <a
                  className={`file-link-${index}`}
                  href={file.url}
                  download={file.name}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  {iconElement}
                  <FileName>{file.name}</FileName>
                </a>
              )}
              {onRemoveFile && (
                <RemoveFileButton onClick={() => onRemoveFile(file.id)}>×</RemoveFileButton>
              )}
            </FileDisplayContainer>
          </React.Fragment>
        );
      })}
    </>
  );
};

export default FileToDisplay;
